import { FormInstance } from "antd";
import * as React from "react";
import { isEqualFormValues } from "src/components/MForm/node/isEqualFormValues";

import { PageBlocker } from "../PageBlocker";

export interface FormBlockerProps<T> {
  form: FormInstance<T>;
  initialData: T | null;
  expired?: boolean; // Используется для случаев если нет смысла проверять значения полей. Например, происходит удаление объекта
}

/**
 * Предотвращает переход на другую страницу, если в форме есть несохраненные изменения.
 * Использует NavBlocker в качестве базового механизма блокировки навигации.
 */
export const FormBlocker = <T extends Record<string, unknown>>({
  form,
  initialData,
  expired,
}: FormBlockerProps<T>) => {
  const changed = () => {
    if (!initialData || expired) {
      return false;
    }
    const currentValues = form.getFieldsValue();
    return !isEqualFormValues(currentValues, initialData);
  };
  return <PageBlocker changed={changed} />;
};
